// baseurl for
const BASE_URL =process.env.REACT_APP_API_BASE_URL;

export const endpoint = {
  LOGIN: `${BASE_URL}/login`,
  REGISTER: `${BASE_URL}/register`,

  // Apis related to youtube channels
  CHANNELS: `${BASE_URL}/onboarding/youtube/list-channels`,
  CHANNEL_DETAILS: `${BASE_URL}/onboarding/youtube/channels`,
  CHANNEL_EDIT: `${BASE_URL}/onboarding/youtube/edit-channel`,
  CHANNEL_DELETE: `${BASE_URL}/onboarding/youtube/delink-channel`,
  YOUTUBE_AUTH_URL: `${BASE_URL}/onboarding/youtube/oauth_url`,

  // Apis related to Instagram
  INSTAGRAM_AUTH_URL: `${BASE_URL}/onboarding/instagram/get_auth_url`,
  INSTAGRAM_DELINK: `${BASE_URL}/onboarding/instagram/delink_account`,

  // Apis related to videoPerformance
  VIDEO_PERFORMANCE_CHART1: `${BASE_URL}/analytics/youtube/video_ctr_analytics`,
  VIDEO_PERFORMANCE_CHART2: `${BASE_URL}/analytics/youtube/video_metrics`,
  VIDEO_PERFORMANCE_CHART3: `${BASE_URL}/analytics/youtube/retention_analysis`,
  VIDEO_PERFORMANCE_CHART4: `${BASE_URL}/analytics/youtube/total_watch_hours`,
  VIDEO_PERFORMANCE_CHART5: `${BASE_URL}/analytics/youtube/get_videos_details`,
  VIDEO_PERFORMANCE_CHART6: `${BASE_URL}/analytics/youtube/video_sharing_analytics`,
  VIDEO_PERFORMANCE_CHART7: `${BASE_URL}/analytics/youtube/get_card_details`,
  VIDEO_PERFORMANCE_CHART8: `${BASE_URL}/analytics/youtube/performance_analytics`,
  VIDEO_PERFORMANCE_CHART9: `${BASE_URL}/analytics/youtube/playlist_engagement`,
  STATIC_DATA: `${BASE_URL}/audience/youtube/get_kpi`,

  // Apis related to version control
  VERSION_CONTROL: `${BASE_URL}/audience/youtube/Versioncontrol`,

  //Apis related to invites
  INVITE_API_ENDPOINT: `${BASE_URL}/Invites/youtube/invitehandler`,

  // https://an2sldwgo0.execute-api.ap-south-1.amazonaws.com/stage1/analytics/youtube/performance_analytics
  // User Settings(MasterLogin)
  MASTER_LOGIN: `${BASE_URL}/public/users/user_session`,
  VALIDATE_CHANNEL: `${BASE_URL}/public/users/validate-channels`,
  GET_USERS_LIST: `${BASE_URL}/public/users/Getusers`,
  BACK_TO_SESSION: `${BASE_URL}/public/users/admin_session`,
  
  // User profile management
  UPDATE_USER_PROFILE: `${BASE_URL}/public/users/user_profile`,
  GET_USER_DETAILS: `${BASE_URL}/public/users/user_details`,

  // Performance Overview KPIs
  PERFORMANCE_OVERVIEW_KPIS: `${BASE_URL}/analytics/youtube/performance_kpis`,

  // Audience 
  audience: {
    totalAudience: `${BASE_URL}/audience/youtube/total_audience`,
    newSubscribers: `${BASE_URL}/audience/youtube/total_subscribers`,
    netSubscribers: `${BASE_URL}/audience/youtube/net_subscribers`,
    subscriberRate: `${BASE_URL}/audience/youtube/subscriber_rate`,
    audienceRetention: `${BASE_URL}/audience/youtube/retention`,
    ageDistribution: `${BASE_URL}/audience/youtube/age_distribution`,
    genderDistribution: `${BASE_URL}/audience/youtube/gender_distribution`,
    topCountries: `${BASE_URL}/audience/youtube/top_countries`,
    deviceDistribution: `${BASE_URL}/audience/youtube/device_distribution`,
    interestCategories: `${BASE_URL}/audience/youtube/interest_categories`,
    trafficSources: `${BASE_URL}/audience/youtube/traffic_sources`,
    sharesDistribution: `${BASE_URL}/audience/youtube/sharing_platforms`,
    premiumViews: `${BASE_URL}/audience/youtube/premium_views`,
    cardPerformance: `${BASE_URL}/audience/youtube/card_performance`,
    videoList: `${BASE_URL}/audience/youtube/video_list`,
  },
};
